import React, { useEffect } from "react";
import { Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import { NoDataFoundTable } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Pagination from "../../../Pagination";

const DeletedLUPReport = ({
  tableRef,
  onMouseDown,
  reportDeletedList,
  softDeleteRestoreLupReportMetadata,
  Show,
  Hide,
  Title,
  getDeletedLupReportMetadatasData,
  reportDeletedListCount,
  pageNumberDeleted,
  itemsPerPageDeleted,
  setPageNumberDeleted,
  setItemsPerPageDeleted,
}) => {
  const startIndex = (pageNumberDeleted - 1) * itemsPerPageDeleted;
  const totalPage = Math.ceil(reportDeletedListCount / itemsPerPageDeleted);
  useEffect(() => {
    getDeletedLupReportMetadatasData(pageNumberDeleted, itemsPerPageDeleted);
  }, [pageNumberDeleted, itemsPerPageDeleted]);
  return (
    <>
      <Offcanvas
        show={Show}
        onHide={Hide}
        style={{ width: 600 }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {reportDeletedListCount === 0 ? (
            <div
              className="hstack justify-content-center"
              style={{ height: "calc(100vh - 44px)" }}
            >
              <NoDataFoundTable MSG={"No Event Metadata deleted yet."} />
            </div>
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Report Number</th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Report Name</th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 3)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Restore
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {reportDeletedList?.map((report, index) => (
                    <tr key={index} title="View Details">
                      <td className="text-center">{index + 1 + startIndex}.</td>
                      <td>{report?.reportNumber}</td>
                      <td>{report?.reportName}</td>
                      <td className="text-center" title="Restore">
                        <MdRestore
                          style={{ fontSize: 16 }}
                          onClick={(e) =>
                            softDeleteRestoreLupReportMetadata(
                              report?._id,
                              "restore"
                            )
                          }
                          className="text-success CP"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumberDeleted}
                  itemsPerPage={itemsPerPageDeleted}
                  totalItems={reportDeletedListCount}
                  setPageNumber={setPageNumberDeleted}
                  setItemsPerPage={setItemsPerPageDeleted}
                />
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DeletedLUPReport;
